<template>
  <div v-loading="loading">
    <table class="table table-vertical-center table-bordered" style="min-height: 100px">
      <thead>
      <tr style="background-color: #F8F8F8;">
        <th scope="col" class="w-[100px] header-title">Lần test</th>
        <th scope="col" class="min-w-[120px] header-title nowrap">Speaking</th>
        <th scope="col" class="min-w-[120px] header-title nowrap">Listening</th>
        <th scope="col" class="min-w-[120px] header-title nowrap">Reading</th>
        <th scope="col" class="min-w-[120px] header-title nowrap">Writing</th>
        <th scope="col" class="min-w-[120px] header-title nowrap">Vocab</th>
        <th scope="col" class="min-w-[120px] header-title nowrap">Overall</th>
        <th scope="col" class="min-w-[180px] header-title">Thời gian cập nhật</th>
        <th scope="col" class="min-w-[150px] header-title">Người cập nhật</th>
      </tr>
      </thead>
      <tbody v-if="detailPoint?.length > 0">
      <tr v-for="item of detailPoint" :key="item?.id" style="border: 1px solid #EBEDF3; border-top: 0">
        <td>{{ item?.testNumber }}</td>
        <td style="text-align: start">{{ item?.speaking }}</td>
        <td style="text-align: start">{{ item?.listening }}</td>
        <td style="text-align: start">{{ item?.reading }}</td>
        <td style="text-align: start">{{ item?.written }}</td>
        <td>{{ item?.vocabulary }}</td>
        <td style="text-align: start">{{ item?.overall }}</td>
        <td style="text-align: start">{{ item?.updatedAt }}</td>
        <td style="text-align: center">
          <span style="display: block; padding: 5px 8px; border-radius: 5px">{{ item?.userUpdated }}</span>
        </td>
      </tr>
      </tbody>
      <tbody v-else>
      <tr style="word-break: break-word; white-space: nowrap; position: relative; border: 1px solid #EBEDF3">
        <label style="position: absolute; left: 50%; translate: -50%; top: 10px">Không có dữ liệu</label>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {GET_SCORE_RESULT} from "@/core/services/store/examSchedule/examSchedule";
import {PointDetailModel} from "../model/RetestModel";

export default {
  name: 'TableDetailPoint',
  data() {
    return {
      detailPoint: [],
      loading: false,
    }
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  mounted() {
    this.getDetailPoint()
  },
  methods: {
    getDetailPoint() {
      this.loading = true
      this.$store.dispatch(GET_SCORE_RESULT, {id: this.record.id}).then(res => {
        if (!res.error) {
          this.detailPoint = res.data.map(item => new PointDetailModel(item))
        }
      }).catch(e => {
        console.log(e)
      }).finally(() => this.loading = false)
    },
  }
}
</script>

<style scoped>
  .header-title {
    background: #F8F8F8;
    text-align: start;
    word-break: break-word;
  }
  .nowrap {
    white-space: nowrap;
  }
</style>